import React, { useState } from 'react';
import axios from 'axios';
import './CreateQR.css';

const CreateQR = () => {
  const [quantity, setQuantity] = useState(1);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value);
    setQuantity(value > 0 ? value : 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post('/api/v1/create-bulk', {
        quantity,
        base_url: window.location.origin
      }, {
        responseType: 'blob' // Important for handling the zip file response
      });

      // Create a download link for the zip file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `qr-codes-${quantity}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setIsLoading(false);
      setResponse({ success: true, quantity });
    } catch (error) {
      setError(error.response?.data?.detail || 'Произошла ошибка при создании QR-кодов');
      setIsLoading(false);
    }
  };

  return (
    <div className="create-qr container">
      <h2 className="text-center mb-4">Создать QR-коды</h2>
      
      {!response ? (
        <div className="card p-4">
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-4">
              <label htmlFor="quantity" className="form-label">Количество QR-кодов:</label>
              <input
                type="number"
                id="quantity"
                className="form-control form-control-lg"
                value={quantity}
                onChange={handleQuantityChange}
                min="1"
                required
              />
            </div>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                disabled={isLoading}
              >
                {isLoading ? 'Создание...' : 'Создать QR-коды'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="response-card card p-4">
          <h3 className="text-center mb-3">QR-коды созданы!</h3>
          <div className="alert alert-success">
            <p>Архив с {response.quantity} QR-кодами был успешно скачан.</p>
          </div>
          
          <div className="text-center mt-4">
            <button
              className="btn btn-primary"
              onClick={() => setResponse(null)}
            >
              Создать еще QR-коды
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateQR;
